// src/components/SelectorCasaRapido.js
import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { FaHome, FaChevronDown, FaCheck, FaExchangeAlt } from 'react-icons/fa';
import './SelectorCasaRapido.css';

const SelectorCasaRapido = () => {
    const { misCasas, casaActiva, casaActivaId, cambiarCasaActiva } = useAuth();
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    if (!Array.isArray(misCasas) || misCasas.length <= 1) return null;

    const getLabel = (casa) => {
        if (!casa) return 'Propiedad';
        const partes = [];
        if (casa.calle) partes.push(casa.calle);
        if (casa.numero || casa.numeroExterior) partes.push(`No. ${casa.numero || casa.numeroExterior}`);
        if (casa.manzana) partes.push(`Mza ${casa.manzana}`);
        if (casa.lote) partes.push(`Lote ${casa.lote}`);
        return partes.length > 0 ? partes.join(' ') : `Casa ${casa.id}`;
    };

    const currentLabel = getLabel(casaActiva || misCasas[0]);

    const handleSelect = (id) => {
        cambiarCasaActiva(id);
        setIsOpen(false);
    };

    return (
        <div className="selector-casa-rapido-container" ref={containerRef}>
            <button
                type="button"
                className={`btn-selector-casa-rapido ${isOpen ? 'active' : ''}`}
                onClick={() => setIsOpen(!isOpen)}
                title="Cambiar casa activa"
            >
                <FaHome className="icon-home" />
                <span className="current-casa-name">{currentLabel}</span>
                <FaChevronDown className="icon-arrow" />
            </button>

            {isOpen && (
                <div className="dropdown-casa-menu">
                    <div className="dropdown-casa-header">
                        <FaExchangeAlt />
                        <span>Tus Propiedades</span>
                    </div>
                    <div className="dropdown-casa-list">
                        {misCasas.map((item) => {
                            const isSelected = item.id === (casaActivaId || casaActiva?.id);
                            return (
                                <button
                                    key={item.id}
                                    type="button"
                                    className={`dropdown-casa-item ${isSelected ? 'selected' : ''}`}
                                    onClick={() => handleSelect(item.id)}
                                >
                                    <span>{getLabel(item)}</span>
                                    {isSelected && <FaCheck className="item-check" />}
                                </button>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};

export default SelectorCasaRapido;
